export default "__VITE_ASSET__CGLbN9UC__"